// TODO: This will be refactored back to the NPM open source module and be part of the pict-section-entitymanagement this weekend
// TODO: For now treat this as a slightly enhanced stub

const libPictProvider = require('pict-provider');

class EntityProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.HasInitialized = false;
		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;
		/** @type {any} */
		this.options;

		// Check to see that the Entiy was passed in with the options object or not
		if (typeof(this.options.Entity) !== 'string')
		{
			this.Entity = 'Unknown';
			this.HasEntity = false;
			this.pict.log.warn(`Entity not defined or is not a string in provider options; initializeEntity must be called manually.`);
		}
		else if (this.options.Entity.length === 0)
		{
			this.Entity = 'Unknown';
			this.HasEntity = false;
			this.pict.log.warn(`Entity is an empty string in provider options; initializeEntity must be called manually.`);
		}
		else
		{
			this.Entity = this.options.Entity;
			this.HasEntity = true;
		}
	}

	onInitializeAsync(fCallback)
	{
		const tmpAnticipate = this.pict.newAnticipate();

		if (this.HasEntity)
		{
			tmpAnticipate.anticipate(this.initializeEntity.bind(this));
		}
		tmpAnticipate.wait(fCallback);
	}

	setEntity(pEntity)
	{
		if (this.HasEntity)
		{
			this.pict.log.error(`Entity already set to ${this.Entity} so setEntity cannot be called again.`);
			return false;
		}
		if (typeof(pEntity) !== 'string')
		{
			this.pict.log.error(`Entity must be a string when calling setEntity.`);
			return false;
		}
		if (pEntity.length === 0)
		{
			this.pict.log.error(`Entity must be a non-empty string when calling setEntity.`);
			return false;
		}

		this.Entity = pEntity;
		this.HasEntity = true;
		return true;
	}

	initializeEntity(fCallback)
	{
		if (!this.HasEntity)
		{
			this.pict.log.error(`Entity not set so initializeEntity cannot be called.`);
			return fCallback('Entity not set so initializeEntity cannot be called.');
		}
		if (this.HasInitialized)
		{
			this.pict.log.error(`Entity already initialized so initializeEntity cannot be called again.`);
			return fCallback('Entity already initialized so initializeEntity cannot be called again.');
		}

		const tmpAnticipate = this.pict.newAnticipate();

		tmpAnticipate.anticipate(this.loadSchema.bind(this));

		return tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error initializing Entity [${this.Entity}]: ${pError}`);
				}
				else
				{
					this.pict.log.info(`Entity [${this.Entity}] successfully initialized.`);
					this.HasInitialized = true;
				}
				return fCallback(pError);
			});
	}


	loadSchema(fCallback)
	{
		const tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () =>
		{};
		return tmpCallback();
	}

	// This may seem inordinately complex but it is architected to allow hooks on the record load before and after.
	loadRecords(fCallback, pMeadowFilter, pRecordCursorStart, pRecordCount)
	{
		if (!this.HasInitialized)
		{
			this.pict.log.error(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
			return fCallback(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
		}

		const tmpAnticipate = this.pict.newAnticipate();

		// Default to 0 for the cursor start
		const tmpRecordCursorStart = (typeof(pRecordCursorStart) === 'number') ? pRecordCursorStart : 0;
		// Default to 100 records
		const tmpRecordCount = (typeof(pRecordCount) === 'number') ? pRecordCount : 100;
		// Default to no meadow filter
		const tmpMeadowFilter = (typeof(pMeadowFilter) === 'string') ? pMeadowFilter : false;

		// Construct the URI
		let tmpURI = `${this.Entity}s`;
		if (tmpMeadowFilter)
		{
			tmpURI += `/${tmpMeadowFilter}`;
		}
		tmpURI += `/${tmpRecordCursorStart}/${tmpRecordCount}`;

		// Create a container object for the request (we may tack more onto this for other types of requests)
		const tmpRequestResponse = {};

		tmpAnticipate.anticipate(
			(fRequestCallback) =>
			{
				return this.pict.HeadlightRestClient.getJSON(tmpURI,
					(pError, pResponse) =>
					{
						tmpRequestResponse.Response = pResponse;
						return fRequestCallback(pError);
					});
			});

		tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error loading records for [${this.Entity}] from cursor ${tmpRecordCursorStart} max records ${tmpRecordCount} filtered to ${tmpMeadowFilter}: ${pError}`);
				}
				else
				{
					this.pict.log.info(`Loaded ${tmpRequestResponse.Response.length} records loaded for [${this.Entity}] from cursor ${tmpRecordCursorStart} max records ${tmpRecordCount} filtered to ${tmpMeadowFilter}.`);
				}
				return fCallback(pError, tmpRequestResponse.Response);
			},
		);
	}

	loadRecordsToAddress(fCallback, pAddress, pMeadowFilter, pRecordCursorStart, pRecordCount)
	{
		return this.loadRecords(
			(pLoadError, pRecords) =>
			{
				if (pLoadError)
				{
					this.pict.log.error(`Error loading records for [${this.Entity}] to address ${pAddress}: ${pLoadError}`);
				}
				else
				{
					this.pict.manifest.setValueByHash(this.pict, pAddress, pRecords);
				}
				return fCallback(pLoadError, pRecords);
			}, pMeadowFilter, pRecordCursorStart, pRecordCount);
	}


	// This may seem inordinately complex but it is architected to allow hooks on the record load before and after.
	loadRecordByID(fCallback, pIDEntity)
	{
		if (!this.HasInitialized)
		{
			this.pict.log.error(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
			return fCallback(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
		}

		if (typeof(pIDEntity) == 'undefined')
		{
			this.pict.log.error(`IDEntity not provided to loadRecordByID in the ${this.Entity} provider.`);
			return fCallback(`IDEntity not provided to loadRecordByID in the ${this.Entity} provider.`);
		}

		const tmpAnticipate = this.pict.newAnticipate();

		// Construct the URI
		let tmpURI = `${this.Entity}`;
		// TODO: Guards on the data type?  We want to at least support string and number but maybe function?  aaah.
		tmpURI += `/${pIDEntity}`;

		// Create a container object for the request (we may tack more onto this for other types of requests)
		const tmpRequestResponse = {};

		tmpAnticipate.anticipate(
			(fRequestCallback) =>
			{
				return this.pict.HeadlightRestClient.getJSON(tmpURI,
					(pError, pResponse) =>
					{
						tmpRequestResponse.Response = pResponse;
						return fRequestCallback(pError);
					});
			});

		return tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error loading record for [${this.Entity}] by ID ${pIDEntity} URI [${tmpURI}]: ${pError}`);
				}
				else
				{
					this.pict.log.info(`Record loaded for [${this.Entity}] by ID ${pIDEntity}.`);
				}
				return fCallback(pError, tmpRequestResponse.Response);
			},
		);
	}

	loadRecordByIDToAddress(fCallback, pAddress, pIDEntity)
	{
		return this.loadRecordByID(
			(pLoadError, pRecords) =>
			{
				if (pLoadError)
				{
					this.pict.log.error(`Error loading records for [${this.Entity}] to address ${pAddress}: ${pLoadError}`);
				}
				else
				{
					this.pict.manifest.setValueByHash(this.pict, pAddress, pRecords);
				}
				return fCallback(pLoadError, pRecords);
			}, pIDEntity);
	}

	upsertRecord(fCallback, pRecord)
	{
		if (!this.HasInitialized)
		{
			this.pict.log.error(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
			return fCallback(`Entity [${this.Entity}] not initialized so records cannot be loaded.`);
		}
		if (typeof(pRecord) != 'object')
		{
			this.pict.log.error(`Record must be an object when calling upsertRecord.`);
			return fCallback(`Record must be an object when calling upsertRecord.`);
		}

		const tmpAnticipate = this.pict.newAnticipate();

		// Construct the URI
		const tmpURI = `${this.Entity}/Upsert`;

		// Create a container object for the request (we may tack more onto this for other types of requests)
		const tmpRequestResponse = {};

		tmpAnticipate.anticipate(
			(fRequestCallback) =>
			{
				return this.pict.HeadlightRestClient.putJSON(tmpURI, pRecord,
					(pError, pResponse) =>
					{
						tmpRequestResponse.Response = pResponse;
						return fRequestCallback(pError);
					});
			});

		return tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error Upserting record for [${this.Entity}]: ${pError}`);
				}
				else
				{
					this.pict.log.error(`Record upserted for [${this.Entity}].`);
				}
				return fCallback(pError, tmpRequestResponse.Response);
			},
		);
	}

	upsertRecordToAddress(fCallback, pAddress, pRecord)
	{
		return this.upsertRecord(
			(pUpsertError, pRecords) =>
			{
				if (pUpsertError)
				{
					this.pict.log.error(`Error upserting record for [${this.Entity}] to address ${pAddress}: ${pUpsertError}`);
				}
				else
				{
					this.pict.manifest.setValueByHash(this.pict, pAddress, pRecords);
				}
				return fCallback(pUpsertError, pRecords);
			}, pRecord);
	}
}

module.exports = EntityProvider;

module.exports.default_configuration = (
	{
		ProviderIdentifier: 'InterimEntityProvider',
	});
